import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../apollo-client';
// @ts-expect-error
import {appHistory} from '../history';
import {store} from '../store';
import {AuthRoot} from '../ui/auth/auth-root';

import 'less/auth.less';

const mountDiv = document.querySelector('#pre-auth-react-mount');
if (mountDiv) {
    ReactDOM.render(
        <Provider store={store}>
            <ApolloProvider client={nutApolloClient}>
                <ReactHooksApolloProvider client={nutApolloClient}>
                    <Router history={appHistory}>
                        <AuthRoot />
                    </Router>
                </ReactHooksApolloProvider>
            </ApolloProvider>
        </Provider>,
        mountDiv
    );
}
